/** Formata um valor numérico como moeda brasileira (R$). */
export const formatCurrency = (value?: number | null): string => {
  if (value === undefined || value === null) return "—";
  return value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};

/**
 * Formata o nome do combustível para exibição em selo/badge.
 * Ex.: "DIESEL S-10" → "Diesel S-10"; mantém sufixos técnicos (S-10, S-500) em caixa alta.
 */
export const formatCombustivel = (value?: string | null): string => {
  const s = (value ?? "").trim();
  if (!s) return "—";
  return s
    .toLowerCase()
    .replace(/\b([a-zà-ú])/g, (c) => c.toUpperCase())
    .replace(/\bS-?(\d+)\b/gi, (_, n) => `S-${n}`);
};

/**
 * Cor do combustível no padrão ANP (para selo/chip): Diesel S-10 = cinza,
 * Diesel S-500 = vermelho. Default (desconhecido) = cinza neutro. Retorna hex
 * inline (texto/fundo/borda), no mesmo estilo do badge "Cliente base".
 */
export const corCombustivel = (
  produto?: string | null
): { fg: string; bg: string; border: string } => {
  const p = (produto ?? "").toUpperCase();
  if (/S-?500/.test(p)) return { fg: "#DC2626", bg: "#FEE2E2", border: "#FCA5A5" }; // vermelho ANP (S-500)
  return { fg: "#374151", bg: "#F3F4F6", border: "#D1D5DB" }; // cinza (S-10 / default)
};

/** Formata uma string de data ISO para o padrão DD/MM/AAAA. */
export const formatDate = (value?: string | null): string => {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleDateString("pt-BR");
  } catch {
    return value;
  }
};

/** Formata uma string de data/hora ISO para DD/MM/AAAA HH:mm. */
export const formatDateTime = (value?: string | null): string => {
  if (!value) return "—";
  try {
    return new Date(value).toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return value;
  }
};
